export async function copyCurrentLink(): Promise<boolean> {
  const url = typeof window !== "undefined" ? window.location.href : "";
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(url);
      return true;
    }
  } catch {
    // fall through to legacy approach
  }

  try {
    const input = document.createElement("textarea");
    input.value = url;
    input.setAttribute("readonly", "readonly");
    input.style.position = "fixed";
    input.style.opacity = "0";
    document.body.appendChild(input);
    input.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(input);
    return ok;
  } catch {
    return false;
  }
}